import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ responsive, token }) => ({
  organizationList: {
    maxHeight: 500,
    overflowY: 'auto',
    overflowX: 'hidden'
  },

  loginActions: {
    width: '100%'
  },

  loginDivider: {
    margin: '0 !important',

    '.ant-divider-inner-text': {
      color: `${token.colorTextDescription} !important`
    }
  },

  socialButtonsGrid: {
    width: '100%',
    display: 'grid',
    gap: 12
  },

  socialButtonsSingle: {
    gridTemplateColumns: '1fr'
  },

  socialButtonsText: {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',

    [responsive.sm]: {
      gridTemplateColumns: '1fr'
    }
  },

  socialButtonsIcon: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',

    [responsive.sm]: {
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr))'
    }
  },

  socialButton: {
    width: '100%'
  },

  socialIconOnlyButton: {
    paddingInline: 0
  },

  socialButtonTooltipTrigger: {
    display: 'block',
    width: '100%'
  },

  authFooter: {
    width: '100%'
  },

  loginInlineAuth: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 40,
    width: '100%'
  },

  loginInlinePrimary: {
    flex: '1 1 280px',
    minWidth: 0,
    maxWidth: 340
  },

  loginInlineQr: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center'
  },

  qrPanel: {
    width: '100%'
  },

  qrCompactPanel: {
    pointerEvents: 'auto',
    width: 220,
    padding: 0,
    textAlign: 'center'
  },

  qrCodeFrame: {
    position: 'relative',
    width: 244,
    minHeight: 244,
    overflow: 'hidden',
    borderRadius: 14,
    background: token.colorBgContainer,
    boxShadow: token.boxShadowSecondary,

    '& .ant-qrcode': {
      border: '0 !important',
      padding: '0 !important',
      background: 'transparent !important'
    },

    '& canvas': {
      display: 'block'
    }
  },

  qrCompactCodeFrame: {
    width: 144,
    minHeight: 144,
    padding: 12,
    boxSizing: 'border-box',
    borderRadius: 12
  },

  qrRefreshOverlay: {
    position: 'absolute',
    inset: 0,
    borderRadius: 14,
    background: 'rgba(255, 255, 255, 0.72)',
    backdropFilter: 'blur(3px)',
    transition: 'opacity 180ms ease'
  },

  qrRefreshButton: {
    border: 0,
    boxShadow: token.boxShadowTertiary
  },

  qrCompactCaption: {
    width: '100%'
  },

  qrCompactTitle: {
    fontSize: token.fontSize,
    lineHeight: '20px',
    color: `${token.colorText} !important`
  },

  qrCompactDescription: {
    fontSize: token.fontSizeSM,
    lineHeight: '18px',
    color: `${token.colorTextSecondary} !important`
  },

  qrSkeleton: {
    width: '220px !important',
    height: '220px !important'
  },

  qrCompactSkeleton: {
    width: '120px !important',
    height: '120px !important'
  },

  qrStatusText: {
    textAlign: 'center',
    fontVariantNumeric: 'tabular-nums'
  }
}))
